import React, { useRef, useEffect } from "react";
import { Box } from "@mui/material";
import { Question } from "./utils/CourseTree";
import { MockProblemContainer } from "./v2/mocktour/MockProblemContainer";
import axios from "axios";
import DOMPurify from "dompurify";

interface GPPTextProps {
  currentQuestion: Question;
}

export const GPPText = ({ currentQuestion }: GPPTextProps) => {
  const shadowRootRef = useRef<any>(null);

  useEffect(() => {
    if (currentQuestion.static_problem_url && shadowRootRef.current) {
      axios
        .get(currentQuestion.static_problem_url, { responseType: "text" })
        .then((response) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(response.data, "text/html");

          // Extract the base URL to prepend to relative image paths
          const baseUrl =
            currentQuestion.static_problem_url?.match(/^(https?:\/\/[^/]+)\//i);
          if (baseUrl) {
            doc.querySelectorAll("img").forEach((img) => {
              const src = img.getAttribute("src");
              // Check if the img src is relative and not an absolute URL
              if (
                src &&
                !src.startsWith("http://") &&
                !src.startsWith("https://") &&
                !src.startsWith("//")
              ) {
                img.src = `${baseUrl[0]}${currentQuestion.id}/${src}`;
              }
            });
          }

          // load styles
          const styles = doc.querySelectorAll("head style");
          console.log(styles);
          const shadowRoot = shadowRootRef.current?.attachShadow({ mode: "open" });

          shadowRoot.innerHTML = "";
          Array.from(styles).forEach((style) => {
            shadowRoot.appendChild(style.cloneNode(true));
          });

          //shadowRoot.innerHTML += doc.body.innerHTML;
          const sanitizedContent = DOMPurify.sanitize(doc.body.innerHTML, {
            RETURN_DOM_FRAGMENT: true,
            RETURN_DOM_IMPORT: true,
          });
          shadowRoot.appendChild(sanitizedContent);
        })
        .catch((error) => console.error("Failed to fetch HTML content:", error));
    }
  }, [currentQuestion]);

  return (
    <MockProblemContainer currentQuestion={currentQuestion}>
      <Box ref={shadowRootRef} />
    </MockProblemContainer>
  );
};
